/*
4. index.js
Görev: React uygulamasını DOM'a bağlayan dosyadır.
İşlev: Uygulamanızın başlangıç noktasıdır. 
App.js bileşenini root elementine render eder.
Öneri: Bu dosya genelde değişmez. 
Ancak, global ayarlar veya React Router gibi sağlayıcıları eklemek için düzenlenebilir.
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/index.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);



